import { toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "limits-cell"
}
const _hoisted_2 = { class: "tag-list" }
const _hoisted_3 = { class: "tag-list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_popover = _resolveComponent("el-popover")!

  return (_ctx.limits && _ctx.limits.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createTextVNode(_toDisplayString(_ctx.getLimitTitle(_ctx.limits[0])) + " ", 1 /* TEXT */),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.limits[0].segmentList, (segment) => {
            return (_openBlock(), _createBlock(_component_el_tag, {
              key: segment.segmentId,
              type: "info"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(segment.name), 1 /* TEXT */)
              ]),
              _: 2 /* DYNAMIC */
            }, 1024 /* DYNAMIC_SLOTS */))
          }), 128 /* KEYED_FRAGMENT */))
        ]),
        _createVNode(_component_el_popover, {
          "popper-class": "limits-popover",
          width: 500,
          trigger: "click",
          placement: "right"
        }, {
          reference: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createElementVNode("a", null, "Details", -1 /* CACHED */)
          ]))]),
          default: _withCtx(() => [
            _createElementVNode("h4", null, _toDisplayString(_ctx.popoverTitle), 1 /* TEXT */),
            _createVNode(_component_el_table, {
              "max-height": "400",
              size: "small",
              data: _ctx.limits,
              border: "",
              "show-header": false
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, { width: "120px" }, {
                  default: _withCtx(({ row }) => [
                    _createTextVNode(_toDisplayString(_ctx.getLimitTitle(row)), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_el_table_column, { "max-width": "500px" }, {
                  default: _withCtx(({ row }) => [
                    _createElementVNode("div", _hoisted_3, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.segmentList, (segment) => {
                        return (_openBlock(), _createBlock(_component_el_tag, {
                          key: segment.segmentId,
                          type: "info"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(segment.name), 1 /* TEXT */)
                          ]),
                          _: 2 /* DYNAMIC */
                        }, 1024 /* DYNAMIC_SLOTS */))
                      }), 128 /* KEYED_FRAGMENT */))
                    ])
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["data"])
          ]),
          _: 1 /* STABLE */
        })
      ]))
    : _createCommentVNode("v-if", true)
}